<button mat-flat-button (click)="addKeyValues(DialogComponent)" color="primary" [matBadge]="numberKeyValues$|async">
  {{ title }}
</button>
@if (specials) {
  <button style="margin-left: 10px"
    mat-flat-button color="accent"
    matBadgeColor="accent"
    [matBadge]="numberKeyValues$|async"
    (click)="clickSpecialButton(DialogSpecialComponent)"
    >
    {{ specials.key.traduction|translate }}
  </button>
}


<ng-template #DialogComponent>
  <mat-dialog-content class="flex-direction-column flex-center-center width-container">
    <mat-card [formGroup]="form">
      <mat-card-content class="flex-center-center flex-direction-row w100" style="display: flex">
        <div class="width-key">
          <app-auto-complete-form
            class="width-form-field"
            [title]="'IotDevices.key'|translate"
            [items]="[]"
            appearance="fill"
            [hiddenClearButton]="true"
            formControlName="addingKey"
            >

          </app-auto-complete-form>
        </div>
        <div class="width-value">
          @if (addingKey$|async|transformValueByPredicateFunction:getPossibleValuesPredicate:possibleValues; as values) {
            @switch (values.type) {
              @case (typeForm.ELENCO_VINCOLATO) {
                <mat-form-field appearance="fill">
                  <mat-label>{{ 'IotDevices.value'|translate }}</mat-label>
                  <mat-select formControlName="addingValue">
                    @for (pValue of values.possibleValues; track pValue) {
                      <mat-option [value]="pValue.registerValue">{{ pValue.html }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @case (typeForm.ELENCO_APERTO) {
                <app-auto-complete-form
                  class="width-form-field"
                  [title]="'IotDevices.value'|translate"
                  [items]="values.possibleValues!"
                  appearance="fill"
                  [hiddenClearButton]="true"
                  formControlName="addingValue"
                  >

                </app-auto-complete-form>
              }
              @default {
                <mat-form-field class="w100">
                  <mat-label>{{ 'IotDevices.value'|translate }}</mat-label>
                  <input matInput formControlName="addingValue">
                </mat-form-field>
              }
            }
          }
        </div>
        <div class="width-button">
          <button mat-icon-button color="accent" (click)="addKeyValue()" [disabled]="disableAddButton$|async">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        @if (errorMessages$|async; as errors) {
          <div class="width-error">
            <mat-error>
              @for (key of errors.keys; track key) {
                @if (!$last) {
                  {{ key }},
                } @else {
                  {{ key }}.&nbsp;
                }
              }
              {{ errors.message|translate }}
            </mat-error>
          </div>
        }
      </mat-card-content>
    </mat-card>

    @if (keyValuesInArray$|async; as values) {
      <mat-card style="margin-top: 5px">
        <mat-card-content>
          @for (value of values; track value; let index = $index) {
            <div class="flex-center-center flex-direction-row">
              <div class="width-key"
                [ngClass]="value|transformValueByPredicateFunction:getKeyCssClassPredicate:(addingKey$|async)">
                {{ value.key }}
              </div>
              <div class="width-value">
                <app-truncate-text text="{{value.value}}"
                  [maxRows]="1"
                  >
                </app-truncate-text>
              </div>
              <div class="width-button flex-center-center flex-direction-row">
                <button mat-icon-button color="warn" (click)="deleteKeyValue(value)">
                  <mat-icon>delete</mat-icon>
                </button>
                <button mat-icon-button color="accent" (click)="editKeyValue(value)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </div>
            <mat-divider></mat-divider>
          }
        </mat-card-content>
      </mat-card>
    }
  </mat-dialog-content>
  <div mat-dialog-actions>
    <button mat-flat-button [mat-dialog-close]="undefined" color="accent">
      {{ 'close'|translate }}
    </button>
  </div>
</ng-template>

<ng-template #DialogSpecialComponent>
  <mat-dialog-content class="flex-direction-column flex-center-center width-container">
    <mat-card [formGroup]="specialButtonForm">
      <mat-card-content class="flex-center-center flex-direction-row w100" style="display: flex">
        @for (special of specials?.possibleValues; track special) {
          @switch (special.type) {
            @case (typeForm.CHECKBOX) {
              <div class="w100">
                <mat-checkbox [formControlName]="special.key">
                  <mat-label>{{ special.traduction|translate }}</mat-label>
                </mat-checkbox>
              </div>
            }
            @case (typeForm.ELENCO_VINCOLATO) {
              <div class="w100">
                <mat-form-field appearance="fill">
                  <mat-label>{{ special.traduction|translate }}</mat-label>
                  <mat-select [formControlName]="special.key">
                    @for (pValue of special.values; track pValue) {
                      <mat-option [value]="pValue.registerValue">{{ pValue.noTraduction }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @case (typeForm.ELENCO_APERTO) {
              <div class="w100">
                <app-auto-complete-form
                  class="width-form-field"
                  registerOnChangeKeyValue="registerValue"
                  [title]=" special.traduction|translate "
                  [items]="special.values|transformValueByPredicateFunction:getDataFormPredicate"
                  appearance="fill"
                  [hiddenClearButton]="true"
                  [formControlName]="special.key"
                  >

                </app-auto-complete-form>
              </div>
            }
            @default {
              <div class="w100">
                <mat-form-field class="w100">
                  <mat-label>{{ special.traduction|translate }}</mat-label>
                  <input matInput [formControlName]="special.key">
                </mat-form-field>
              </div>
            }

          }
        }

        <div class="width-button">
          <button mat-icon-button color="accent" (click)="addKeySpecialValue()"
            [disabled]="disableAddSpecialButton$|async">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>

  </mat-dialog-content>
  <div mat-dialog-actions>
    <button mat-flat-button [mat-dialog-close]="undefined" color="accent">
      {{ 'close'|translate }}
    </button>
  </div>
</ng-template>